

import React, { useState, useEffect, useMemo } from "react";
import axios from '../api/axiosConfig';
import {
    Box,
    Pagination,
    Skeleton,
    Button,
    Chip,
    Typography,
    Stack,
    Avatar,

} from "@mui/material";

import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, TextField, Paper } from "@mui/material";
import JemaatDetailModal from "../components/JemaatDetailModal";


import { getInitials, stringToColor, hitungUmur } from "../utils/DataHelper";

import { useTheme, useMediaQuery } from "@mui/material";
import DH from '../utils/DataHelper'


export default function PilgrimsTable() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const rowsPerPage = 100;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleOpenDetail = (row) => {
        setSelectedRecord(row);
        setModalOpen(true);
    };



    // ------------------------
    // 🔥 API CALL HERE
    // ------------------------
    const fetchData = async (query = {}) => {
        try {
            setLoading(true);

            const params = new URLSearchParams(query).toString();
            const url = `/jemaat.php?${params}`;

            const resp = await axios.get(url);
            setRows(resp.data); // API must return array of rows
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };


    // Load initial data
    useEffect(() => {
        fetchData();
    }, []);

    // ------------------------
    // 🔍 Client-side filtering
    // ------------------------
    const filteredRows = useMemo(() => {
        if (!search) return rows;
        const term = search.toLowerCase();
        return rows.filter(
            (r) =>
                r.name_full?.toLowerCase().includes(term) ||
                r.idjemaat?.toLowerCase().includes(term) ||
                r.phone_mobile?.toLowerCase().includes(term)
        );
    }, [rows, search]);

    const exportToExcel = () => {
        const exportData = filteredRows.map(row => ({
            ID: row.idjemaat,
            FullName: row.name_full,
            Nick: row.name_nick,
            Phone: row.phone_mobile,
            Status: row.status_jemaat,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Pilgrims");

        XLSX.writeFile(wb, "pilgrims.xlsx");
    };

    // ------------------------
    // 📄 Pagination (100 rows)
    // ------------------------






    const paginatedRows = useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        return filteredRows.slice(start, start + rowsPerPage);
    }, [filteredRows, page]);

    return (
        <>
            <Box sx={{
                height: isMobile ? "calc(100dvh - 80px)" : "calc(100dvh - 26px)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}>
                <Typography
                    variant="h5"
                    sx={{
                        mb: 2,
                        fontWeight: 700,
                        letterSpacing: "0.4px",
                    }}
                >
                    Data Jemaat
                </Typography>



                <Box
                    sx={{
                        mb: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pl: 0.5,
                    }}
                >
                    {/* Google Search Box */}
                    <Paper
                        elevation={0}
                        sx={{ 
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            maxHeight: 45,
                            maxWidth: 500,
                            p: "6px 12px",
                            borderRadius: "40px",
                             boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                            transition: "0.3s ease",
                            "&:hover": {
                                boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
                            },
                            "&:focus-within": {
                                borderColor: "#4285f4",
                                boxShadow: "0 0 0 3px rgba(66,133,244,0.25)",
                            },
                        }}
                    >
                        <SearchIcon sx={{ opacity: 0.6, mr: 1 }} />

                        <TextField
                            placeholder="Cari Jemaat..."
                            fullWidth
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                            }}
                            sx={{
                                "&:before": { borderBottom: "none !important" },
                                "&:after": { borderBottom: "none !important" },
                            }}
                            inputProps={{ style: { fontSize: 14 } }}
                        />

                        {search.length > 0 && (
                            <IconButton
                                onClick={() => setSearch("")}
                                size="small"
                                sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
                            >
                                <ClearIcon />
                            </IconButton>
                        )}
                    </Paper>


                    {/* Export Button */}
                    {/* <Button
                        variant="contained"
                        color="success"
                        onClick={exportToExcel}
                        sx={{
                            ml: 2,
                            height: 50,
                            borderRadius: 3,
                            textTransform: "none",
                            px: 3,
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
                        }}
                        startIcon={<DownloadIcon />}
                    >
                        Download
                    </Button> */}
                </Box>



                {/* Main container */}
                {/* <Card sx={{ borderRadius: 0, overflow: "hidden", boxShadow: 1, mt: 2 }}>
                    <CardContent sx={{ p: 0,sx:{overflowX:'auto',background:'#DDDDDD'}    }}> */}

                <Box sx={{
                    flex: 1,               // 🔥 fills available height
                    overflowY: "auto",
                    mt: 1,
                    borderRadius: 1,
                    WebkitOverflowScrolling: "touch",
                }}>
                    {/* Skeleton Loader */}
                    {loading ? (
                        [...Array(12)].map((_, i) => (
                            <Skeleton
                                key={i}
                                variant="rectangular"
                                height={45}
                                sx={{ my: 0.5, borderRadius: 1 }}
                            />
                        ))
                    ) : (

                        <>


                            <Stack spacing={1.5}>
                                {paginatedRows.map((row) => {
                                    const avatarColor = stringToColor(row.name_full);

                                    return (
                                        <Box
                                            key={row.id}
                                            onClick={() => handleOpenDetail(row)}
                                            sx={{
                                                p: 2,
                                                bgcolor: "background.paper",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                                cursor: "pointer",
                                                transition: "all .2s",
                                                "&:hover": {
                                                    bgcolor: "action.hover",
                                                    transform: "translateY(-1px)",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                                },
                                            }}
                                        >
                                            {/* Header */}
                                            <Stack direction="row" spacing={1.5} alignItems="center">
                                                {/* Avatar */}
                                                <Avatar
                                                    sx={{
                                                        bgcolor: avatarColor,
                                                        color: "#fff",
                                                        fontWeight: 700,
                                                        width: 42,
                                                        height: 42,
                                                        fontSize: 15,
                                                        alignSelf: "flex-start",
                                                    }}
                                                >
                                                    {getInitials(row.name_full)}
                                                </Avatar>

                                                <Box flex={1}>
                                                    <Typography fontSize={18} fontWeight={700}>
                                                        {row.name_full}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {row.alamat}
                                                    </Typography>
                                                    <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            {row.idjemaat}
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            •
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            <Typography variant="body2" color="text.secondary">
                                                                {hitungUmur(row.lahir_date)}
                                                            </Typography>

                                                        </Typography>
                                                    </Stack>
                                                </Box>

                                                <Chip
                                                    label={row.isbetaniamember === 1 ? "Member" : "Non-Member"}
                                                    color={row.isbetaniamember === 1 ? "success" : "primary"}
                                                    size="small"
                                                    sx={{ fontWeight: 700 }}
                                                />
                                            </Stack>


                                        </Box>
                                    );
                                })}
                            </Stack>



                        </>
                    )}

                </Box>
                {!loading && (
                    <Box
                        sx={{
                            flexShrink: 0,
                            borderTop: theme => `1px solid ${theme.palette.divider}`,
                            bgcolor: "background.paper",
                            px: 1,
                            pb: "env(safe-area-inset-bottom)", // iOS fix
                        }}
                    >
                        <Stack
                            direction="row"
                            spacing={isMobile ? 0.5 : 2}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Pagination
                                count={Math.ceil(filteredRows.length / rowsPerPage)}
                                page={page}
                                onChange={(e, v) => setPage(v)}
                                siblingCount={0}
                                boundaryCount={1}
                                shape="rounded"
                                size={isMobile ? "small" : "medium"}
                                sx={{
                                    boxShadow: "none",
                                    bgcolor: "background.subtle",

                                    "& .MuiPaginationItem-root": {
                                        borderRadius: "12px",
                                        fontSize: "13px",
                                        minWidth: 36,
                                        height: 36,
                                        bgcolor: "background.paper",
                                        color: "text.primary",
                                    },

                                    "& .MuiPaginationItem-root:hover": {
                                        bgcolor: "action.hover",
                                    },

                                    "& .Mui-selected": {
                                        bgcolor: "primary.main",
                                        color: "primary.contrastText",
                                        "&:hover": {
                                            bgcolor: "primary.dark",
                                        },
                                    },
                                }}
                            />

                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    bgcolor: "background.subtle",
                                    borderRadius: 2,
                                    textAlign: "center",
                                    border: theme => `1px solid ${theme.palette.divider}`,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 18,
                                        fontWeight: 600,
                                        color: "text.primary",
                                    }}
                                >
                                    {filteredRows.length.toLocaleString()}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: 10,
                                        fontWeight: 500,
                                        color: "text.secondary",
                                    }}
                                >
                                    Record
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>
                )}

                {/* </CardContent>

                </Card> */}
            </Box>
            <JemaatDetailModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                data={selectedRecord}
            />
        </ >
    );
}

